const ManualXMLLoad = () => import('@/components/manualVault/XMLLoad.vue')
const ManualCSVLoad = () => import('@/components/manualVault/CSVLoad.vue')
const ManualXMLLoadsAdmin = () => import('@/components/manualVault/AdminXMLLoads.vue')
const ManualCSVLoadsAdmin = () => import('@/components/manualVault/AdminCSVLoads.vue')

const manualLoadPermissions = [
  'cargar_xmls',
  'cargar_lista_raya',
  'cfdis_cargados',
  'administrar_lista_raya'
]

export const manualLoadRoutes = [
  {
    path: '/manual-load',
    meta: { breadcrumb: 'Bóveda ERP', requiresAuth: true, permissions: manualLoadPermissions },
    children: [
      { path: 'load-xmls', component: ManualXMLLoad, meta: { breadcrumb: 'Carga XMLs', permissions: [manualLoadPermissions[0]] } },
      { path: 'load-csv', component: ManualCSVLoad, meta: { breadcrumb: 'Carga Lista de Raya', permissions: [manualLoadPermissions[1]] } },
      { path: 'admin-load-xmls', component: ManualXMLLoadsAdmin, meta: { breadcrumb: 'CFDIs Cargados', permissions: [manualLoadPermissions[2]] } },
      { path: 'admin-load-csvs', component: ManualCSVLoadsAdmin, meta: { breadcrumb: 'Administrar Listas de Rayas', permissions: [manualLoadPermissions[3]] } },
    ],
  },
]
